import React from 'react';

const inputClass =
  'tap-target w-full rounded-xl border border-zinc-200 bg-white py-3 text-base text-zinc-900 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/25 disabled:cursor-not-allowed disabled:opacity-60';

/**
 * @param {{ label: string, id: string, icon?: React.ReactNode, isRTL?: boolean, dir?: string, suffix?: React.ReactNode }} props
 */
export function FormInput({
  label,
  id,
  icon,
  isRTL,
  dir,
  suffix,
  className = '',
  ...inputProps
}) {
  const pad = icon ? (isRTL ? 'pr-11 pl-4' : 'pl-11 pr-4') : 'px-4';
  const iconPos = isRTL ? 'right-3' : 'left-3';

  return (
    <div className={className}>
      <label htmlFor={id} className="mb-2 block text-sm font-semibold text-zinc-800">
        {label}
      </label>
      <div className="relative">
        {icon ? (
          <span
            className={`pointer-events-none absolute top-1/2 -translate-y-1/2 text-brand-600 ${iconPos}`}
          >
            {icon}
          </span>
        ) : null}
        <input id={id} className={`${inputClass} ${pad}`} dir={dir} {...inputProps} />
        {suffix ? (
          <span className={`absolute top-1/2 -translate-y-1/2 ${isRTL ? 'left-3' : 'right-3'}`}>
            {suffix}
          </span>
        ) : null}
      </div>
    </div>
  );
}
